import { RowDataPCComponent } from "../../components/PCComponentIncompletePage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the PCComponentTable factory
 */
class PCComponentRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/pc-components/read-range"
        this.accessData = "components"
    }

    create(component: any): RowDataPCComponent {
        const rowDataOrder: RowDataPCComponent = {

            id: component.id,
            itemName: component.itemName,                   //
            displayName: component.displayName,             //
            xItemId: component.xItemId,
            category: component.category,                   //
            xItemCode: component.xItemCode,
            xItemType: component.xItemType,
            xItemModel: component.xItemModel,
            brand: component.brand,                         //
            xCategory: component.xCategory, 
            price: component.price,                         //
            weight: component.weight,
            height: component.height,
            width: component.width, 
            moboFormFactor: component.moboFormFactor, 
            moboSocket: component.moboSocket, 
            moboChipset: component.moboChipset, 
            moboRamType: component.moboRamType, 
            caseFormFactor: component.caseFormFactor, 
            casePsuFormFactor: component.casePsuFormFactor, 
            caseGpuLength: component.caseGpuLength,          //NEED CLARIFICATION
            caseCoolerHeight: component.caseCoolerHeight,       //NEED CLARIFICATION
            caseRadiatorLength: component.caseRadiatorLength,     //NEED CLARIFICATION
            coolerHeatExchangeMedium: component.coolerHeatExchangeMedium,
            coolerType: component.coolerType,
            coolerSocket: component.coolerSocket, 
            coolerHeight: component.coolerHeight, 
            coolerRadiatorLength: component.coolerRadiatorLength,  
            ramType: component.ramType,
            ramDDR: component.ramDDR,                 //NEED CLARIFICATION 
            ramAmount: component.ramAmount, 
            psuFormFactor: component.psuFormFactor, 
            psu80PlusStandard: component.psu80PlusStandard, 
            psuWattage: component.psuWattage,             //NEED CLARIFICATION
            psuPCIE5: component.psuPCIE5,                  //NEED CLARIFICATION 
            ssdM2Type: component.ssdM2Type, 
            ssdCapacity: component.ssdCapacity,            //NEED CLARIFICATION
            ssdSize: component.ssdSize,                //NEED CLARIFICATION
            cpuTdp: component.cpuTdp, 
            cpuSocket: component.cpuSocket, 
            cpuChipset: component.cpuChipset, 
            gpuLength: component.gpuLength,
            gpuRecommendedPsu: component.gpuRecommendedPsu,
            show: component.show,
            isCompatibilityReady: component.isCompatibilityReady, 
            createdAt: component.createdAt, 
            updatedAt: component.updatedAt,

            priceScheme: component.priceScheme ? JSON.parse(component.priceScheme) : null,

            action: "",
        };
        return rowDataOrder;
    }

    generateParams(params: any, extra: any) {
        params["new"] = extra.current
        return params
    }
}

let pcComponentRow: PCComponentRow | null = null;

export default function getPCComponentRow(): PCComponentRow {
    if (pcComponentRow === null)
        pcComponentRow = new PCComponentRow()
    return pcComponentRow
}